export const loadingState = (state) => state.strategy.loading;
export const isLoadingDeleteSelect = (state) => state.strategy.isLoadingDelete;

export const strategiesState = (state) => state.strategy.strategies;

export const communityStrategiesState = (state) =>
  state.strategy.communityStrategies;

export const errorMessageState = (state) => state.strategy.errorMessage;

export const selectBacktestStatusLog = (state) =>
  state.strategy.backtestStatusLog;

export const refetchStrategiesState = (state) =>
  state.strategy.refetchStrategies;

export const startedBacktestState = (state) => state.strategy.startedBacktest;

export const selectIsBacktestComplete = (state) =>
  state.strategy.isBacktestComplete;

export const selectStrategyType = (state) => state.strategy.strategyType;
